export const IJwtTokenConstant = {
    ACCESS_TOKEN_KEY: 'access_token',
    REFRESH_TOKEN_KEY: 'refresh_token',
    TOKEN_TYPE_KEY: 'token_type',
    EXPIRES_IN_KEY: 'expires_in'    
}